import { NextSeo } from 'next-seo';
import Breadcrumb from '@/components/breadcrumb';
import LayoutBase from '@/components/layout-base';
import ContentContactFormPage from '@/content/content-contact-form-page';
import contentLayoutBaseData from '@/content/content-layout-base-data';
import i18nMessagesLoad from '@/lib/i18n-messages-load';
import { localizationContextFromGetStaticPropsContext } from '@/lib/localization-contenxt';
import revalidateAfter from '@/lib/revalidate-after';
import type { NextGetStaticProps, NextPageWithLayout } from './_app';

type ContactFormPageProps = {};

const ContactFormPage: NextPageWithLayout<ContactFormPageProps> = () => {
  const pageTitle = 'Kontaktní formulář';
  return (
    <>
      <NextSeo title={pageTitle} />

      <main className='content-container'>
        <Breadcrumb className='py-4'>
          <Breadcrumb.Item href='/kontaktni-formular' isCurrenctPage={true} position={1}>
            {pageTitle}
          </Breadcrumb.Item>
        </Breadcrumb>
        <h1 className='heading-page'>{pageTitle}</h1>
        <ContentContactFormPage />
      </main>
    </>
  );
};

ContactFormPage.displayName = 'ContactFormPage';

ContactFormPage.getLayout = (page) => {
  return <LayoutBase>{page}</LayoutBase>;
};

export default ContactFormPage;

export const getStaticProps: NextGetStaticProps<ContactFormPageProps> = async (getStaticPropsContext) => {
  const localizationContext = localizationContextFromGetStaticPropsContext(getStaticPropsContext);
  const intlMessages = await i18nMessagesLoad(localizationContext);
  const layoutData = await contentLayoutBaseData(localizationContext);

  return {
    props: {
      intlMessages,
      layoutData,
    },
    revalidate: revalidateAfter('1h'),
  };
};
